import React from 'react'
import DashboardPage from '../pages/admin_portal/DashboardPage'
import AccountPage from '../pages/admin_portal/AccountPage'
import { Routes, Route, Navigate } from "react-router-dom";
import CompanyPage from '../pages/admin_portal/CompanyPage';
import ProcessPage from '../pages/admin_portal/ProcessPage';
import StagePage from '../pages/admin_portal/StagePage';
// import PricingPage from '../pages/admin_portal/PricingPage';
// import PaymentTermsPage from '../pages/admin_portal/PaymentTermsPage';
import InvoicePage from '../pages/admin_portal/InvoicePage';
import MyProfile from '../pages/admin_portal/MyProfile';
import SmtpConfigPage from '../pages/admin_portal/SmtpConfigPage';
import AssignProcessPage from '../pages/admin_portal/AssignProcessPage';
import EmailNotificationPage from '../pages/admin_portal/EmailNotificationPage';

const AdminPortalRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<DashboardPage />} />
      <Route path="/users" element={<AccountPage />} />
      <Route path="/company" element={<CompanyPage />} />
      <Route path="/process" element={<ProcessPage />} />
      <Route path="/stage/stage" element={<StagePage />} />
      {/* <Route path="/pricing" element={<PricingPage />} />
      <Route path="/payment-terms" element={<PaymentTermsPage />} /> */}

      <Route path="/invoices" element={<InvoicePage />} />
      <Route path="*" element={<Navigate replace to="/admin" />} />
      <Route path="/profile" element={<MyProfile />} />
      <Route path="/reports/email_configuration" element={<SmtpConfigPage />} />
      <Route path="/reports/email_notification" element={<EmailNotificationPage />} />
      <Route path="/assign-stage" element={<AssignProcessPage />} />
      <Route path="/stage/assign-stage" element={<AssignProcessPage />} />
    </Routes>
  )
}

export default AdminPortalRoutes;
